import { UserStateService } from '../services/user-state.service';

/**
 * App Initializer Factory
 * This runs BEFORE the Angular app bootstraps, ensuring user info is loaded
 * before any routing or guards execute
 */
export function appInitializerFactory(userStateService: UserStateService) {
  return async (): Promise<void> => {
    try {
      console.log('App Initializer: Loading user information...');
      await userStateService.loadUserInfo();
      console.log('App Initializer: User information loaded successfully');
    } catch (error) {
      console.error('App Initializer: Error loading user information:', error);
      // Don't throw - let the app start even if user info fails to load
    }
  };
}
